import { Injectable } from '@angular/core';
import { NotificationService } from '../notification/notification.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  constructor(
    private notificationService: NotificationService
  ) { }

  handleTableErrors(err: any, table: any) {
    if (err && err.error) {
      this.notificationService.showErrorMessage(
        'ERROR-MESSAGES.ERROR-BACKEND',
        err.error.errorId ? err.error.errorId : 'unknown', err.message
      );
    }
    if (table) {
      table.setLoaderSpinner(false);
    }
  }

  handleErrors(err: any) {
    this.notificationService.showCustomMessage(
      'SNACKBAR.ERROR_MESSAGES.ERROR_UNEXPECTED', 'SNACKBAR.ERROR_MESSAGES.NOT_SAVED'
    );
  }
}
